<div class="tabs-container">
  <tabs (tabClicked)="onTabClicked($event)">
    <tab title="Not Submitted">
      @if (selectedTab === programStatuses.InProcess) {
        <ag-grid-angular class="data-grid " [gridOptions]="notSubmittedGridOptions" [rowData]="notSubmitted$ | async" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Not Submitted'"></ag-grid-angular>
      }
    </tab>
    <tab title="Awaiting Review">
      @if (selectedTab === programStatuses.AwaitingReview) {
        <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="pending$ | async" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Awaiting Review'"></ag-grid-angular>
      }
    </tab>
    <tab title="Returned For Correction">
      @if (selectedTab === programStatuses.ReturnedForCorrection) {
        <ag-grid-angular class="data-grid " [gridOptions]="returnedGridOptions" [rowData]="returned$ | async" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Returned For Correction'"></ag-grid-angular>
      }
    </tab>
    <tab title="Active Wells">
      @if (selectedTab === programStatuses.Active) {
        <ag-grid-angular class="data-grid " [gridOptions]="activeGridOptions" [rowData]="active$ | async" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Active Wells'"></ag-grid-angular>
      }
    </tab>
    <tab title="Exited Wells">
      @if (selectedTab === programStatuses.Plugged) {
        <ag-grid-angular class="data-grid " [rowData]="exited$ | async" [gridOptions]="exitedGridOptions" [excelStyles]="excelStyles"  [attr.aria-label]="widgetTitle + ' - Exited Wells'"></ag-grid-angular>
      }
    </tab>
  </tabs>
</div>
